import { createFeatureSelector, createSelector } from "@ngrx/store";
import {
	modifMutuellePatientAdapter,
	ModifMutuellePatientState,
} from "@featuresAY/mutuelle-web-ay/store/modif-mutuelle-patient.reducer";
import { ModifMutuellePatientFeaturedAction } from "@featuresAY/mutuelle-web-ay/store/modif-mutuelle-patient.action";

/*export*/
const selectFeature = createFeatureSelector<ModifMutuellePatientState>(ModifMutuellePatientFeaturedAction.stateName);

const patientAdapterSelectors = modifMutuellePatientAdapter.getSelectors();

export const selectAllPatient = createSelector(selectFeature, patientAdapterSelectors.selectAll);

export const selectModifMutuellePatient = createSelector(selectFeature, (state) => state.currentPatient);
export const selectModifMutuelleMobilePatient = createSelector(selectFeature, (state) => state.currentMobilePatient);
export const selectModifMutuelle = createSelector(selectFeature, (state) => state.currentMutuelleAttestationPatient);
export const selectModifDocumentMutuelleAttestation = createSelector(
	selectFeature,
	(state) => state.documentAttestation,
);
export const selectModifMutuelleLoading = createSelector(selectFeature, (state) => state.loading);
export const selectModifMutuelleLoaded = createSelector(selectFeature, (state) => state.loaded);
